<div class="app-client-picker">
  <div class="input-group">
    <span class="input-group-text"><i class="fe fe-search"></i></span>
    <input
      class="form-control"
      type="text"
      autocomplete="off"
      placeholder="Procure pelo nome ou e-mail…"
      [value]="query()"
      (input)="search($any($event.target).value)"
      (focus)="search(query())"
      (blur)="blur()" />
  </div>

  @if (selected(); as client) {
    <small class="text-muted d-block mt-1">
      <i class="fe fe-user-check text-success me-1"></i>
      Cliente existente: {{ client.email }}@if (client.organizationName) { · {{ client.organizationName }} }
    </small>
  } @else if (query().trim().length >= 2 && currentEmail()?.trim()) {
    <small class="text-muted d-block mt-1">
      <i class="fe fe-user-plus me-1"></i>
      Novo cliente — será criado ao gravar, com o e-mail indicado ao lado.
    </small>
  }

  @if (open() && (results().length || searching())) {
    <div class="app-client-picker-menu">
      @if (searching()) {
        <div class="px-3 py-2 text-muted small">A procurar…</div>
      } @else {
        @for (client of results(); track client.id) {
          <button type="button" class="app-client-picker-item" (click)="choose(client)">
            <span class="fw-semibold">{{ client.name }}</span>
            <small class="text-muted d-block">
              {{ client.email }}@if (client.organizationName) { · {{ client.organizationName }} }
            </small>
          </button>
        }
      }
    </div>
  }
</div>
